module.exports = __webpack_public_path__ + "static/media/Logo Boolean.5aaf8770.png";